import { animated as t, to as n, useTransition as e, useSpring as r } from "@react-spring/web";
import { useTheme as i, radiansToDegrees as a, positionFromAngle as o, degreesToRadians as u, midAngle as l, useMotionConfig as s, usePropertyAccessor as d, textPropsByEngine as f, getDistance as c, getAngle as g } from "@nivo/core";
import { jsx as p, jsxs as h } from "react/jsx-runtime";
import { useMemo as v, createElement as A, useCallback as x } from "react";
import { useInheritedColor as R } from "@nivo/colors";
import { line as m, arc as y } from "d3-shape";

function M() {
  return M = Object.assign || function (t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }, M.apply(this, arguments);
}

var k = {
  pointerEvents: "none"
},
    C = function C(n) {
  var e = n.label,
      r = n.style,
      a = i();
  return p(t.g, {
    transform: r.transform,
    opacity: r.progress,
    style: k,
    children: p(t.text, {
      textAnchor: "middle",
      dominantBaseline: "central",
      style: M({}, a.labels.text, {
        fill: r.textColor
      }),
      children: e
    })
  });
},
    b = function b(t) {
  var n = t % (2 * Math.PI);
  return n < 0 && (n += 2 * Math.PI), n;
},
    L = function L(t, n) {
  return t.filter(function (t) {
    return Math.abs(a(t.arc.endAngle - t.arc.startAngle)) >= n;
  });
},
    P = function P(t, n, e, r, i) {
  return ["A", t, t, 0, n, e, r, i].join(" ");
},
    O = ["startAngle", "middleAngle", "endAngle", "innerRadius", "centerRadius", "outerRadius", "pushIn", "pushOut"],
    E = {
  startAngle: {
    enter: function enter(t) {
      return M({}, t, {
        endAngle: t.startAngle
      });
    },
    update: function update(t) {
      return t;
    },
    leave: function leave(t) {
      return M({}, t, {
        startAngle: t.endAngle
      });
    }
  },
  middleAngle: {
    enter: function enter(t) {
      var n = t.startAngle + (t.endAngle - t.startAngle) / 2;
      return M({}, t, {
        startAngle: n,
        endAngle: n
      });
    },
    update: function update(t) {
      return t;
    },
    leave: function leave(t) {
      var n = t.startAngle + (t.endAngle - t.startAngle) / 2;
      return M({}, t, {
        startAngle: n,
        endAngle: n
      });
    }
  },
  endAngle: {
    enter: function enter(t) {
      return M({}, t, {
        startAngle: t.endAngle
      });
    },
    update: function update(t) {
      return t;
    },
    leave: function leave(t) {
      return M({}, t, {
        endAngle: t.startAngle
      });
    }
  },
  innerRadius: {
    enter: function enter(t) {
      return M({}, t, {
        outerRadius: t.innerRadius
      });
    },
    update: function update(t) {
      return t;
    },
    leave: function leave(t) {
      return M({}, t, {
        innerRadius: t.outerRadius
      });
    }
  },
  centerRadius: {
    enter: function enter(t) {
      var n = t.innerRadius + (t.outerRadius - t.innerRadius) / 2;
      return M({}, t, {
        innerRadius: n,
        outerRadius: n
      });
    },
    update: function update(t) {
      return t;
    },
    leave: function leave(t) {
      var n = t.innerRadius + (t.outerRadius - t.innerRadius) / 2;
      return M({}, t, {
        innerRadius: n,
        outerRadius: n
      });
    }
  },
  outerRadius: {
    enter: function enter(t) {
      return M({}, t, {
        innerRadius: t.outerRadius
      });
    },
    update: function update(t) {
      return t;
    },
    leave: function leave(t) {
      return M({}, t, {
        outerRadius: t.innerRadius
      });
    }
  },
  pushIn: {
    enter: function enter(t) {
      return M({}, t, {
        innerRadius: t.innerRadius - t.outerRadius + t.innerRadius,
        outerRadius: t.innerRadius
      });
    },
    update: function update(t) {
      return t;
    },
    leave: function leave(t) {
      return M({}, t, {
        innerRadius: t.outerRadius,
        outerRadius: t.outerRadius + t.outerRadius - t.innerRadius
      });
    }
  },
  pushOut: {
    enter: function enter(t) {
      return M({}, t, {
        innerRadius: t.outerRadius,
        outerRadius: t.outerRadius + t.outerRadius - t.innerRadius
      });
    },
    update: function update(t) {
      return t;
    },
    leave: function leave(t) {
      return M({}, t, {
        innerRadius: t.innerRadius - t.outerRadius + t.innerRadius,
        outerRadius: t.innerRadius
      });
    }
  }
},
    I = function I(t, n) {
  return v(function () {
    var e = E[t];
    return {
      enter: function enter(t) {
        return M({
          progress: 0
        }, e.enter(t.arc), n ? n.enter(t) : {});
      },
      update: function update(t) {
        return M({
          progress: 1
        }, e.update(t.arc), n ? n.update(t) : {});
      },
      leave: function leave(t) {
        return M({
          progress: 0
        }, e.leave(t.arc), n ? n.leave(t) : {});
      }
    };
  }, [t, n]);
},
    T = function T(t, n) {
  var e = l(t) - Math.PI / 2,
      r = t.innerRadius + (t.outerRadius - t.innerRadius) * n;
  return o(e, r);
},
    j = function j(t) {
  return function (e, r, i, a) {
    return n([e, r, i, a], function (n, e, r, i) {
      var a = T({
        startAngle: n,
        endAngle: e,
        innerRadius: r,
        outerRadius: i
      }, t);
      return "translate(" + a.x + "," + a.y + ")";
    });
  };
},
    W = function W(t, n, r, i) {
  void 0 === n && (n = .5), void 0 === r && (r = "innerRadius");
  var a = s(),
      o = a.animate,
      u = a.config,
      l = I(r, i);
  return {
    transition: e(t, {
      keys: function keys(t) {
        return t.id;
      },
      initial: l.update,
      from: l.enter,
      enter: l.update,
      update: l.update,
      leave: l.leave,
      config: u,
      immediate: !o
    }),
    interpolate: j(n)
  };
},
    S = function S(t) {
  var n = t.data,
      e = t.offset,
      r = void 0 === e ? .5 : e,
      i = t.skipAngle,
      a = void 0 === i ? 0 : i,
      o = t.computeExtraProps,
      u = void 0 === o ? function () {
    return {};
  } : o;
  return v(function () {
    return L(n, a).map(function (t) {
      var n = T(t.arc, r);
      return M({}, u(t), {
        x: n.x,
        y: n.y,
        data: t
      });
    });
  }, [n, r, a, u]);
},
    B = function B(t) {
  var n = t.center,
      e = t.data,
      r = t.transitionMode,
      o = t.label,
      u = t.radiusOffset,
      l = t.skipAngle,
      s = t.textColor,
      f = t.component,
      c = void 0 === f ? C : f,
      g = d(o),
      h = i(),
      x = R(s, h),
      m = v(function () {
    return e.filter(function (t) {
      return Math.abs(a(t.arc.endAngle - t.arc.startAngle)) >= l;
    });
  }, [e, l]),
      y = W(m, u, r),
      k = y.transition,
      b = y.interpolate,
      L = c;
  return p("g", {
    transform: "translate(" + n[0] + "," + n[1] + ")",
    children: k(function (t, n) {
      return /*#__PURE__*/A(L, {
        key: n.id,
        datum: n,
        label: g(n),
        style: M({}, t, {
          transform: b(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius),
          textColor: x(n)
        })
      });
    })
  });
},
    w = function w(t, n, e) {
  t.textAlign = "center", t.textBaseline = "middle", t.font = e.labels.text.fontSize + "px " + e.labels.text.fontFamily, n.forEach(function (n) {
    t.fillStyle = n.textColor, t.fillText("" + n.label, n.x, n.y);
  });
},
    z = function z(t) {
  var n = t.data,
      e = t.offset,
      r = t.skipAngle,
      a = t.label,
      o = t.textColor,
      u = d(a),
      l = i(),
      s = R(o, l),
      f = x(function (t) {
    return {
      label: u(t),
      textColor: s(t)
    };
  }, [u, s]);
  return S({
    data: n,
    offset: e,
    skipAngle: r,
    computeExtraProps: f
  });
},
    F = C,
    G = function G(n) {
  var e = n.label,
      r = n.style,
      a = i();
  return h(t.g, {
    opacity: r.opacity,
    children: [p(t.path, {
      fill: "none",
      stroke: r.linkColor,
      strokeWidth: r.thickness,
      d: r.path
    }), p(t.text, {
      transform: r.textPosition,
      textAnchor: r.textAnchor,
      dominantBaseline: "central",
      style: M({}, a.labels.text, {
        fill: r.textColor
      }),
      children: e
    })]
  });
},
    q = function q(t) {
  var n = b(t.startAngle + (t.endAngle - t.startAngle) / 2 - Math.PI / 2);
  return n < Math.PI / 2 || n > 1.5 * Math.PI ? "start" : "end";
},
    D = function D(t, n, e, r) {
  var i,
      a,
      u = b(t.startAngle + (t.endAngle - t.startAngle) / 2 - Math.PI / 2),
      l = o(u, t.outerRadius + n),
      s = o(u, t.outerRadius + n + e);
  return u < Math.PI / 2 || u > 1.5 * Math.PI ? (i = "after", a = {
    x: s.x + r,
    y: s.y
  }) : (i = "before", a = {
    x: s.x - r,
    y: s.y
  }), {
    side: i,
    points: [l, s, a]
  };
},
    H = m().x(function (t) {
  return t.x;
}).y(function (t) {
  return t.y;
}),
    J = function J(t, e, r, i, a, o, u) {
  return n([t, e, r, i, a, o, u], function (t, n, e, r, i, a, o) {
    var u = D({
      startAngle: t,
      endAngle: n,
      innerRadius: e,
      outerRadius: r
    }, i, a, o).points;
    return H(u);
  });
},
    K = function K(t, e, r, i) {
  return n([t, e, r, i], function (t, n, e, r) {
    return q({
      startAngle: t,
      endAngle: n,
      innerRadius: e,
      outerRadius: r
    });
  });
},
    N = function N(t, e, r, i, a, o, u, l) {
  return n([t, e, r, i, a, o, u, l], function (t, n, e, r, i, a, o, u) {
    var l = D({
      startAngle: t,
      endAngle: n,
      innerRadius: e,
      outerRadius: r
    }, i, a, o),
        s = l.points,
        d = l.side,
        f = s[2];
    return "before" === d ? f.x -= u : f.x += u, "translate(" + f.x + "," + f.y + ")";
  });
},
    Q = function Q(t) {
  var n = t.data,
      r = t.offset,
      a = void 0 === r ? 0 : r,
      o = t.diagonalLength,
      u = t.straightLength,
      l = t.skipAngle,
      d = void 0 === l ? 0 : l,
      f = t.textOffset,
      c = t.linkColor,
      g = t.textColor,
      p = s(),
      h = p.animate,
      A = p.config,
      x = i(),
      m = R(c, x),
      y = R(g, x),
      M = function (t, n) {
    return v(function () {
      return L(t, n);
    }, [t, n]);
  }(n, d),
      k = function (t) {
    var n = t.offset,
        e = t.diagonalLength,
        r = t.straightLength,
        i = t.textOffset,
        a = t.getLinkColor,
        o = t.getTextColor;
    return v(function () {
      return {
        enter: function enter(t) {
          return {
            startAngle: t.arc.startAngle,
            endAngle: t.arc.endAngle,
            innerRadius: t.arc.innerRadius,
            outerRadius: t.arc.outerRadius,
            offset: n,
            diagonalLength: 0,
            straightLength: 0,
            textOffset: i,
            linkColor: a(t),
            textColor: o(t),
            opacity: 0
          };
        },
        update: function update(t) {
          return {
            startAngle: t.arc.startAngle,
            endAngle: t.arc.endAngle,
            innerRadius: t.arc.innerRadius,
            outerRadius: t.arc.outerRadius,
            offset: n,
            diagonalLength: e,
            straightLength: r,
            textOffset: i,
            linkColor: a(t),
            textColor: o(t),
            opacity: 1
          };
        },
        leave: function leave(t) {
          return {
            startAngle: t.arc.startAngle,
            endAngle: t.arc.endAngle,
            innerRadius: t.arc.innerRadius,
            outerRadius: t.arc.outerRadius,
            offset: n,
            diagonalLength: 0,
            straightLength: 0,
            textOffset: i,
            linkColor: a(t),
            textColor: o(t),
            opacity: 0
          };
        }
      };
    }, [e, r, i, a, o]);
  }({
    offset: a,
    diagonalLength: o,
    straightLength: u,
    textOffset: f,
    getLinkColor: m,
    getTextColor: y
  });

  return {
    transition: e(M, {
      keys: function keys(t) {
        return t.id;
      },
      initial: k.update,
      from: k.enter,
      enter: k.update,
      update: k.update,
      leave: k.leave,
      config: A,
      immediate: !h
    }),
    interpolateLink: J,
    interpolateTextAnchor: K,
    interpolateTextPosition: N
  };
},
    U = function U(t) {
  var n = t.center,
      e = t.data,
      r = t.label,
      i = t.skipAngle,
      a = t.offset,
      o = t.diagonalLength,
      u = t.straightLength,
      l = t.strokeWidth,
      s = t.textOffset,
      f = t.textColor,
      c = t.linkColor,
      g = t.component,
      h = void 0 === g ? G : g,
      v = d(r),
      x = Q({
    data: e,
    skipAngle: i,
    offset: a,
    diagonalLength: o,
    straightLength: u,
    textOffset: s,
    linkColor: c,
    textColor: f
  }),
      R = x.transition,
      m = x.interpolateLink,
      y = x.interpolateTextAnchor,
      k = x.interpolateTextPosition,
      C = h;
  return p("g", {
    transform: "translate(" + n[0] + "," + n[1] + ")",
    children: R(function (t, n) {
      return /*#__PURE__*/A(C, {
        key: n.id,
        datum: n,
        label: v(n),
        style: M({}, t, {
          thickness: l,
          path: m(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, t.offset, t.diagonalLength, t.straightLength),
          textAnchor: y(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius),
          textPosition: k(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, t.offset, t.diagonalLength, t.straightLength, t.textOffset)
        })
      });
    })
  });
},
    V = function V(t, n, e, r) {
  t.textBaseline = "middle", t.font = e.labels.text.fontSize + "px " + e.labels.text.fontFamily, n.forEach(function (n) {
    t.fillStyle = n.textColor, t.textAlign = f.canvas.align[n.textAnchor], t.fillText("" + n.label, n.x, n.y), t.beginPath(), t.strokeStyle = n.linkColor, t.lineWidth = r, n.points.forEach(function (n, e) {
      0 === e ? t.moveTo(n.x, n.y) : t.lineTo(n.x, n.y);
    }), t.stroke();
  });
},
    X = function X(t) {
  var n = t.data,
      e = t.skipAngle,
      r = void 0 === e ? 0 : e,
      i = t.offset,
      o = void 0 === i ? .5 : i,
      u = t.diagonalLength,
      l = t.straightLength,
      s = t.computeExtraProps,
      d = void 0 === s ? function () {
    return {};
  } : s,
      f = v(function () {
    return n.filter(function (t) {
      return Math.abs(a(t.arc.endAngle - t.arc.startAngle)) >= r;
    }).map(function (t) {
      return M({}, D(t.arc, o, u, l), {
        data: t
      });
    });
  }, [n, r, o, u, l]);
  return v(function () {
    return f.map(function (t) {
      return M({}, d(t), t);
    });
  }, [f, d]);
},
    Y = function Y(t) {
  var n = t.data,
      e = t.skipAngle,
      r = t.offset,
      a = t.diagonalLength,
      o = t.straightLength,
      u = t.textOffset,
      l = void 0 === u ? 0 : u,
      s = t.label,
      f = t.linkColor,
      c = t.textColor,
      g = d(s),
      p = i(),
      h = R(f, p),
      v = R(c, p),
      A = x(function (t) {
    var n,
        e = {
      x: t.points[2].x,
      y: t.points[2].y
    };
    return "before" === t.side ? (e.x -= l, n = "end") : (e.x += l, n = "start"), M({}, e, {
      label: g(t.data),
      linkColor: h(t.data),
      textAnchor: n,
      textColor: v(t.data)
    });
  }, [g, h, v, l]);
  return X({
    data: n,
    skipAngle: e,
    offset: r,
    diagonalLength: a,
    straightLength: o,
    computeExtraProps: A
  });
},
    Z = G,
    $ = ["animated"],
    _ = function _(e) {
  var r = e.animated,
      i = function (t, n) {
    if (null == t) return {};
    var e,
        r,
        i = {},
        a = Object.keys(t);

    for (r = 0; r < a.length; r++) {
      e = a[r], n.indexOf(e) >= 0 || (i[e] = t[e]);
    }

    return i;
  }(e, $);

  return p(t.path, M({
    d: n([r.radius, r.startAngle, r.endAngle], function (t, n, e) {
      return function (t, n, e) {
        var r = Math.min(n, e),
            i = Math.max(n, e),
            a = o(u(i), t),
            l = o(u(r), t);

        if (i - r >= 360) {
          var s = o(u(r + 180), t);
          return ["M " + a.x + " " + a.y, P(t, 1, 1, s.x, s.y), "M " + a.x + " " + a.y, P(t, 1, 0, s.x, s.y)].join(" ");
        }

        var d = i - r <= 180 ? 0 : 1;
        return ["M " + a.x + " " + a.y, P(t, d, 0, l.x, l.y)].join(" ");
      }(t, n, e);
    })
  }, i));
},
    tt = function tt(n) {
  var e = n.datum,
      r = n.style,
      i = n.onClick,
      a = n.onMouseEnter,
      o = n.onMouseMove,
      u = n.onMouseLeave,
      l = x(function (t) {
    return null == i ? void 0 : i(e, t);
  }, [i, e]),
      s = x(function (t) {
    return null == a ? void 0 : a(e, t);
  }, [a, e]),
      d = x(function (t) {
    return null == o ? void 0 : o(e, t);
  }, [o, e]),
      f = x(function (t) {
    return null == u ? void 0 : u(e, t);
  }, [u, e]);
  return p(t.path, {
    d: r.path,
    opacity: r.opacity,
    fill: e.fill || r.color,
    stroke: r.borderColor,
    strokeWidth: r.borderWidth,
    onClick: i ? l : void 0,
    onMouseEnter: a ? s : void 0,
    onMouseMove: o ? d : void 0,
    onMouseLeave: u ? f : void 0
  });
},
    nt = function nt(t, e, r, i, a) {
  return n([t, e, r, i], function (t, n, e, r) {
    return a({
      startAngle: t,
      endAngle: n,
      innerRadius: Math.max(0, e),
      outerRadius: Math.max(0, r)
    });
  });
},
    et = function et(t, n, r) {
  void 0 === n && (n = "innerRadius");
  var i = s(),
      a = i.animate,
      o = i.config,
      u = I(n, r);
  return {
    transition: e(t, {
      keys: function keys(t) {
        return t.id;
      },
      initial: u.update,
      from: u.enter,
      enter: u.update,
      update: u.update,
      leave: u.leave,
      config: o,
      immediate: !a
    }),
    interpolate: nt
  };
},
    rt = function rt(t) {
  var n = t.center,
      e = t.data,
      r = t.arcGenerator,
      a = t.borderWidth,
      o = t.borderColor,
      u = t.onClick,
      l = t.onMouseEnter,
      s = t.onMouseMove,
      d = t.onMouseLeave,
      f = t.transitionMode,
      c = t.component,
      g = void 0 === c ? tt : c,
      h = i(),
      v = R(o, h),
      x = et(e, f, {
    enter: function enter(t) {
      return {
        opacity: 0,
        color: t.color,
        borderColor: v(t)
      };
    },
    update: function update(t) {
      return {
        opacity: 1,
        color: t.color,
        borderColor: v(t)
      };
    },
    leave: function leave(t) {
      return {
        opacity: 0,
        color: t.color,
        borderColor: v(t)
      };
    }
  }),
      m = x.transition,
      y = x.interpolate,
      k = g;
  return p("g", {
    transform: "translate(" + n[0] + "," + n[1] + ")",
    children: m(function (t, n) {
      return /*#__PURE__*/A(k, {
        key: n.id,
        datum: n,
        style: M({}, t, {
          borderWidth: a,
          path: y(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, r)
        }),
        onClick: u,
        onMouseEnter: l,
        onMouseMove: s,
        onMouseLeave: d
      });
    })
  });
},
    it = function it(t, n, e, r, i, a) {
  void 0 === a && (a = !0);
  var l = [],
      s = o(u(r), e);
  l.push([s.x, s.y]);
  var d = o(u(i), e);
  l.push([d.x, d.y]);

  for (var f = Math.round(Math.min(r, i)); f <= Math.round(Math.max(r, i)); f++) {
    if (f % 90 == 0) {
      var c = o(u(f), e);
      l.push([c.x, c.y]);
    }
  }

  l = l.map(function (e) {
    var r = e[0],
        i = e[1];
    return [t + r, n + i];
  }), a && l.push([t, n]);
  var g = l.map(function (t) {
    return t[0];
  }),
      p = l.map(function (t) {
    return t[1];
  }),
      h = Math.min.apply(Math, g),
      v = Math.max.apply(Math, g),
      A = Math.min.apply(Math, p);
  return {
    points: l,
    x: h,
    y: A,
    width: v - h,
    height: Math.max.apply(Math, p) - A
  };
},
    at = function at(t, n, e, r, i, a) {
  var o = c(i, a, t, n);
  return o < e && o > r;
},
    ot = function ot(t, n, e, r, i, a, o) {
  if (at(t, n, e, r, a, o)) {
    var u = g(a, o, t, n);
    return i.find(function (t) {
      var n = t.startAngle,
          e = t.endAngle;
      return u >= n && u < e;
    });
  }
},
    ut = function ut(t, n) {
  var e = s(),
      i = e.animate,
      a = e.config,
      o = r({
    startAngle: t.arc.startAngle,
    endAngle: t.arc.endAngle,
    innerRadius: t.arc.innerRadius,
    outerRadius: t.arc.outerRadius,
    config: a,
    immediate: !i
  });
  return M({}, o, {
    path: nt(o.startAngle, o.endAngle, o.innerRadius, o.outerRadius, n)
  });
},
    lt = function lt(t) {
  var n = void 0 === t ? {} : t,
      e = n.cornerRadius,
      r = void 0 === e ? 0 : e,
      i = n.padAngle,
      a = void 0 === i ? 0 : i;
  return v(function () {
    return y().innerRadius(function (t) {
      return t.innerRadius;
    }).outerRadius(function (t) {
      return t.outerRadius;
    }).cornerRadius(r).padAngle(a);
  }, [r, a]);
};

export { F as ArcLabelComponent, B as ArcLabelsLayer, _ as ArcLine, Z as ArcLinkLabelComponent, U as ArcLinkLabelsLayer, tt as ArcShape, rt as ArcsLayer, E as arcTransitionModeById, O as arcTransitionModes, it as computeArcBoundingBox, T as computeArcCenter, D as computeArcLink, q as computeArcLinkTextAnchor, w as drawCanvasArcLabels, V as drawCanvasArcLinkLabels, ot as findArcUnderCursor, nt as interpolateArc, j as interpolateArcCenter, at as isCursorInRing, ut as useAnimatedArc, S as useArcCenters, W as useArcCentersTransition, lt as useArcGenerator, z as useArcLabels, Y as useArcLinkLabels, Q as useArcLinkLabelsTransition, X as useArcLinks, I as useArcTransitionMode, et as useArcsTransition };